"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkillInputT = exports.SkillT = exports.EmailAllowlistInputT = exports.EmailAllowlistEntryT = exports.EmailReceiverInputT = exports.EmailReceiverT = exports.DiscussionItemT = exports.TaskAttachmentT = exports.TaskChecklistItemT = exports.TaskT = exports.TASK_THREAD_READONLY_MARKER_TEXT = exports.LEGACY_REVIEW_TASK_STATUSES = exports.TaskStatusT = exports.TaskStatus = void 0;
const tBox = __importStar(require("@sinclair/typebox"));
const dates_1 = require("./dates");
const meta_types_1 = require("./meta-types");
var TaskStatus;
(function (TaskStatus) {
    TaskStatus[TaskStatus["Archived"] = 50] = "Archived";
    TaskStatus[TaskStatus["Unapproved"] = 80] = "Unapproved";
    TaskStatus[TaskStatus["Pending"] = 100] = "Pending";
    TaskStatus[TaskStatus["Categorising"] = 125] = "Categorising";
    TaskStatus[TaskStatus["Categorised"] = 150] = "Categorised";
    TaskStatus[TaskStatus["AttemptingOneShot"] = 175] = "AttemptingOneShot";
    TaskStatus[TaskStatus["Processed"] = 200] = "Processed";
    TaskStatus[TaskStatus["ProposedComplete"] = 600] = "ProposedComplete";
    TaskStatus[TaskStatus["Completed"] = 900] = "Completed";
})(TaskStatus || (exports.TaskStatus = TaskStatus = {}));
exports.TaskStatusT = tBox.Enum(TaskStatus);
exports.LEGACY_REVIEW_TASK_STATUSES = [601, 602, 603];
exports.TASK_THREAD_READONLY_MARKER_TEXT = 'This thread is read-only. Use the Discussion tab for updates.';
exports.TaskT = tBox.Object({
    ID: tBox.String(),
    CreatedAt: (0, dates_1.DateTimeObjT)(),
    CreatedBy: (0, meta_types_1.MaybeT)(tBox.Number()),
    UpdatedAt: (0, dates_1.DateTimeObjT)(),
    Facility: tBox.Number(),
    SubFacility: (0, meta_types_1.MaybeT)(tBox.Number()),
    ApplicationType: tBox.String(),
    Status: exports.TaskStatusT,
    Title: (0, meta_types_1.MaybeT)(tBox.String()),
    PrimaryNote: tBox.String(),
    SecondaryNote: (0, meta_types_1.MaybeT)(tBox.String()),
    AllowAgents: meta_types_1.tBoolT,
});
exports.TaskChecklistItemT = tBox.Object({
    ID: tBox.Number(),
    Task: tBox.String(),
    ItemName: tBox.String(),
    ClaimedCompleteAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    VerifiedCompleteAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    VerifiedCompleteBy: (0, meta_types_1.MaybeT)(tBox.Number()),
    ts: (0, dates_1.DateTimeObjT)(),
});
exports.TaskAttachmentT = tBox.Object({
    ID: tBox.Number(),
    Task: (0, meta_types_1.MaybeT)(tBox.String()),
    FileGUID: tBox.String(),
    Filename: (0, meta_types_1.MaybeT)(tBox.String()),
    MimeType: tBox.String(),
    CreatedAt: (0, dates_1.DateTimeObjT)(),
    CreatedBy: tBox.Number(),
    ts: (0, dates_1.DateTimeObjT)(),
});
exports.DiscussionItemT = tBox.Object({
    ID: tBox.Number(),
    Task: tBox.String(),
    Timestamp: (0, dates_1.DateTimeObjT)(),
    Author: (0, meta_types_1.MaybeT)(tBox.Number()),
    FileGuid: (0, meta_types_1.MaybeT)(tBox.String()),
    Text: tBox.String(),
    ts: (0, dates_1.DateTimeObjT)(),
});
exports.EmailReceiverT = tBox.Object({
    ID: tBox.Number(),
    EmailAddress: tBox.String(),
    Facility: tBox.Number(),
    SubFacility: (0, meta_types_1.MaybeT)(tBox.Number()),
    ApplicationType: tBox.String(),
    IsDisabled: meta_types_1.tBoolT,
    Description: (0, meta_types_1.MaybeT)(tBox.String()),
    ts: (0, dates_1.DateTimeObjT)(),
});
exports.EmailReceiverInputT = tBox.Object({
    ID: (0, meta_types_1.MaybeT)(tBox.Number()),
    EmailAddress: tBox.String(),
    Facility: tBox.Number(),
    SubFacility: (0, meta_types_1.MaybeT)(tBox.Number()),
    ApplicationType: tBox.String(),
    IsDisabled: meta_types_1.tBoolT,
    Description: (0, meta_types_1.MaybeT)(tBox.String()),
});
exports.EmailAllowlistEntryT = tBox.Object({
    ID: tBox.Number(),
    EmailAddressID: tBox.Number(),
    SenderAddress: tBox.String(),
    Name: (0, meta_types_1.MaybeT)(tBox.String()),
    ts: (0, dates_1.DateTimeObjT)(),
});
exports.EmailAllowlistInputT = tBox.Object({
    ID: (0, meta_types_1.MaybeT)(tBox.Number()),
    EmailAddressID: tBox.Number(),
    SenderAddress: tBox.String(),
    Name: (0, meta_types_1.MaybeT)(tBox.String()),
});
exports.SkillT = tBox.Object({
    ID: tBox.String(),
    Facility: (0, meta_types_1.MaybeT)(tBox.Number()),
    SubFacility: (0, meta_types_1.MaybeT)(tBox.Number()),
    ApplicationType: tBox.String(),
    Title: tBox.String(),
    Description: tBox.String(),
    Document: tBox.String(),
    CreatedAt: (0, dates_1.DateTimeObjT)(),
    CreatedBy: tBox.Number(),
    UpdatedAt: (0, dates_1.DateTimeObjT)(),
    UpdatedBy: tBox.Number(),
    ts: (0, dates_1.DateTimeObjT)(),
});
exports.SkillInputT = tBox.Object({
    ID: (0, meta_types_1.MaybeT)(tBox.String()),
    Facility: (0, meta_types_1.MaybeT)(tBox.Number()),
    SubFacility: (0, meta_types_1.MaybeT)(tBox.Number()),
    ApplicationType: tBox.String(),
    Title: tBox.String(),
    Description: tBox.String(),
    Document: tBox.String(),
});
//# sourceMappingURL=types-agents.js.map